/**
 * To prevent confounding Z-indexing as more components get opinionated on their Z-position, I like to organize it all
 * in one central location. Then, you can work out the global Z-indexing from one spot.
 */
export const Z_INDEX = {
  /**
   * The text at the bottom-left corner that shows the web app's version e.g. `v1.0.1`
   */
  APP_VERSION: 40,

  MOBILE_TOOLBAR: 45,

  COMPETENCY_LIST: 49,

  SIDE_MENU: 50,

  ABOVE_SIDE_MENU: 55,

  MODAL: 100,

  RTL_TOGGLE: 10000,
};
